import React, { useEffect, memo, Suspense, lazy } from 'react';
import { reduxConnect } from '../../common';
import { NewsVideosPageIds, NewsVideosPageRoutePaths } from './newsVideoPageNavTypes';
import { NewsVideoPageLoadingUI } from './newsVideoPageLoadingUI';
import { FeaturedVideosPageMarkupUI } from '../featuredVideos/featuredVideosPageMarkupUI';

const NewsScreenLanding = lazy(() => import('../storySection/newsScreenLanding/newsScreenLanding'));
const FeaturedVideosPage = lazy(() => import('../featuredVideos/featuredVideosPage'));

interface DisplayNewsVideosPageUIProps {
    activePageId: string;
    routePath: string;
    popupId?: string;
    Metadata: any;
}

const mapStoreStateToProps = (storeState: any) => {
    const { pageId, popupId, routePath } = storeState?.appState?.appState || {};

    return {
        activePageId: pageId,
        routePath,
        popupId
    };
};

const mapDispatchToProps = {};

export const DisplayNewsVideosPageUI = memo(reduxConnect(mapStoreStateToProps, mapDispatchToProps)((
    {
        activePageId,
        routePath,
        popupId,
        Metadata
    }: DisplayNewsVideosPageUIProps) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activePageId]);

    if (activePageId?.toLocaleLowerCase() === NewsVideosPageIds.news && routePath === NewsVideosPageRoutePaths.news && !popupId) {
        return (
            <Suspense fallback={<NewsVideoPageLoadingUI />}>
                <NewsScreenLanding />
            </Suspense>
        );
    } else if (activePageId?.toLocaleLowerCase() === NewsVideosPageIds.videos) {
        return (
            <Suspense fallback={<FeaturedVideosPageMarkupUI />}>
                <FeaturedVideosPage Metadata={Metadata} />
            </Suspense>
        );
    } else {
        return null;
    }
}));

DisplayNewsVideosPageUI.displayName = 'DisplayNewsVideosPageUI';